import React from 'react'
import { css } from '@emotion/css'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Text } from '@contrast-security-inc/design-system-typography'
import { IconWarning } from '@contrast-security-inc/design-system-foundations'

export const Warning = ({ children }) => {
  return (
    <Stack
      className={css`
        border-radius: 4px;
        align-items: center;
        padding: 12px;
        background-color: rgba(247, 182, 0, 0.15);
      `}
    >
      <IconWarning color="yellow90" />
      <Text font="body">{children}</Text>
    </Stack>
  )
}
